import { Component, ComponentFactoryResolver, ChangeDetectorRef, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserWizardComponent } from "../user.wizard";
import { UserToGroupComponent } from "./user.to.group.component";
import { UserAddToGroupWizardService } from "./user.add.to.group.wizard.service";
import { UserResultsComponent } from "../user-results/user-results.component";
import {Subscription} from "rxjs";
import { ValuesExchangeProvider } from "@nrwl/common-lib";
import { get, merge } from 'lodash';

@Component({
  selector: "user-wizard",
  providers: [UserAddToGroupWizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../wizard.user.style.scss", "../../../wizard.button.style.scss"]
})
export class UserAddWizardComponent extends UserWizardComponent implements OnInit, OnDestroy{
  subscription: Subscription;
  constructor(
    wizardService: UserAddToGroupWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
    super(wizardService, changeDetectorRef, activatedRoute, factoryResolver);
    
  }
  
  ngOnInit() {
    this.subscription = this.activatedRoute.queryParams.subscribe((data) => {
      const defaultParams = merge({}, JSON.parse(get(data, 'defaultParams', "{}")));
      this.wizardService.editMode = true;
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
      this.exchange.notifyListeners('user-profile-role-group-update-done', false);
    });
  }
 
  resolveComponentType(pageId: any) {
    if(pageId === "user.to.group.html") {
      return UserToGroupComponent;
    }
    else if (pageId === "user-results.html") {
      return UserResultsComponent;
    } 
    else {
      console.error("Unrecognized template name:", pageId);
      return null;
    }
  }

  toggleFinish() {
    const result  = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent();
      this.exchange.notifyListeners('user-profile-role-group-update-done', true);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
